import { Box, Button, Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import DataTable from "../../../../components/dataTable";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { GridRowModel } from "@mui/x-data-grid";
import IRevisaoCotaUsina from "../../../../interfaces/IRevisaoCotaUsina";
import IconButton from "@mui/material/IconButton";
import messages from "../../../../utils/messages";
import serviceFaturaPrevista from "../../../../services/serviceFaturaPrevista";
import serviceFaturaUsina from "../../../../services/serviceFaturaUsina";
import serviceRevisaoCotaUsina from "../../../../services/serviceRevisaoCotaUsina";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { Loader } from "./styles";
export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    data: { open: boolean; id: string; idUsina: string; nomeUsina: string };
    onClose?: any;
}

export default function DialogApprove({ open, data, onClose, onSuccess }: IDialogProps) {
    const [ultimaRevisaoPendente, setUltimaRevisaoPendente] = useState<IRevisaoCotaUsina>();
    const [content, setContent] = useState<any[]>([]);
    const [isLoading, setLoading] = useState(false);

    const {
        handleSubmit,
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({});

    const columns = useMemo(
        () => [
            {
                headerName: "Nº de revisão",
                field: "numeroRevisao",
                type: "number",
                headerAlign: "left",
                width: 120,
            },
            {
                headerName: "Qtd. instalações",
                field: "quantidadeInstalacoes",
                type: "number",
                headerAlign: "left",
                width: 160,
            },
            {
                headerName: "Data admissão",
                field: "dataAdmissaoRevisao",
                type: "date",
                width: 140,
            },
            {
                headerName: "Status",
                field: "statusRevisaoCotaUsina",
                type: "string",
                width: 120,
            },
        ],
        []
    );

    useEffect(() => {
        if (open && data) {
            setLoading(true);

            const filters = {
                statusRevisaoCotaUsina: "Atual,Novo",
                usinaID: data.idUsina,
            };

            serviceRevisaoCotaUsina
                .getWithFilter({ ...filters })
                .then((result) => {
                    if (result?.data.content && result?.data.content.length > 0) {
                        setContent(result?.data.content);
                        setUltimaRevisaoPendente(
                            result?.data.content.find((obj: IRevisaoCotaUsina) => obj.statusRevisaoCotaUsina === "Novo")
                        );
                    }
                })
                .catch((err) => {
                    toast.error("Erro ao obter a última Revisão de Cota para a Usina", err);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setUltimaRevisaoPendente(undefined);
        }
    }, [data]);

    const onSubmit = () => {
        setLoading(true);

        serviceFaturaUsina
            .approve(data.id)
            .then((result) => {
                serviceFaturaPrevista
                    .createByFaturaUsina(data.id)
                    .then((result) => {
                        if (result) {
                            toast.success("Fatura de Usina aprovada com sucesso!");
                        }
                    })
                    .catch((err) => {
                        toast.error("Ocorreu um erro e não foi possível gerar a Fatura Prevista!", err);
                    })
                    .finally(() => {
                        setLoading(false);
                        onClose(true);
                        onSuccess();
                    })               
            })
            .catch((err) => {
                toast.error(messages.approveError, err);
            });
    };

    const handleApprove = async () => {
        setLoading(true);

        serviceRevisaoCotaUsina
            .approve(ultimaRevisaoPendente?.revisaoCotaUsinaID)
            .then((result) => {
                serviceFaturaUsina
                    .approve(data.id)
                    .then((result) => {
                        serviceFaturaPrevista.createByFaturaUsina(data.id).then((result) => {
                            if (result) {
                                toast.success("Revisão de Cota e Fatura de Usina aprovadas com sucesso!");
                            }
                        });                      
                    })
                    .catch((err) => {
                        toast.error("Ocorreu um erro e não foi possível aprovar a Fatura de Usina!", err);
                    })
                    .finally(() => {
                        setLoading(false);
                        onClose(true);
                    });
            })
            .catch((err) => {
                toast.error("Ocorreu um erro e não foi possível aprovar a Revisão de Cota!", err);
                setLoading(false);
            });
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Aprovar fatura de usina
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Grid item xs={12}>
                        {isLoading && (
                            <Loader>
                                <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                            </Loader>
                        )}
                    </Grid>
                    <Box sx={{ height: 200 }}>
                        <DataTable
                            columns={columns}
                            rows={content}
                            rowId={(row: GridRowModel) => row.numeroRevisao}
                            rowCount={content.length}
                            isLoading={isLoading}
                            hideFooterPagination={true}
                        />
                    </Box>
                </DialogContent>

                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleApprove}
                        color="primary"
                        variant="contained"
                        disabled={!ultimaRevisaoPendente || isLoading}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Aprovar Revisão
                    </Button>
                    <Button 
                        type="submit" 
                        color="primary" 
                        variant="contained" 
                        disabled={isLoading} 
                        style={{ width: "159px", height: "44px" }}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
